module.exports = __webpack_public_path__ + "static/media/frosty-head.67e9a3af.svg";